{
  "dropzoneLabel": "Bırakma Bölgesi",
  "selectPlaceholder": "Bir öğe seçin",
  "tableResizer": "Yeniden boyutlandırıcı"
}
